import { createAsyncThunk } from "@reduxjs/toolkit";
import { getMyOrdersApi, placeOrderApi } from "../../api/order.api";
import api from "../../api/apiClient";

export const placeOrder = createAsyncThunk(
  "order/placeOrder",
  async (orderData, { rejectWithValue }) => {
    try {
      const res = await placeOrderApi(orderData);
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to Place Order",
      );
    }
  },
);

export const fetchMyOrders = createAsyncThunk(
  "order/fetchMyOrders",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getMyOrdersApi();
      return res.data;
    } catch (err) {
      return rejectWithValue("Faild To Load Orders");
    }
  },
);

export const cancelOrder = createAsyncThunk(
  "order/cancelOrder",
  async (orderId, { rejectWithValue }) => {
    try {
      const res = await api.patch(`/orders/${orderId}/cancel`);
      return res.data;
    } catch {
      return rejectWithValue("Failed to cancel order");
    }
  },
);

export const completeOrder = createAsyncThunk(
  "order/completeOrder",
  async (orderId, { rejectWithValue }) => {
    try {
      const res = await api.patch(`/orders/${orderId}/complete`);
      return res.data;
    } catch {
      return rejectWithValue("Failed to complete order");
    }
  },
);

export const deleteOrder = createAsyncThunk(
  "order/deleteOrder",
  async (orderId, { rejectWithValue }) => {
    try {
      await api.delete(`/orders/${orderId}`);
      return orderId;
    } catch {
      return rejectWithValue("Failed to delete order");
    }
  },
);
